/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetBrandCashtagRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {SetBrandCashtagResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const setBrandCashtag = (request: SetBrandCashtagRequest, options?: CashRequestOptions) => post<SetBrandCashtagRequest, SetBrandCashtagResponse>("/2.0/cash/set-brand-cashtag", request, {...options, rejectOnError: true })